import { AccordionSummaryProps } from '@mui/material';
import React from 'react';
import * as Styled from './accordion.styles';

const AccordionSummary: React.FC<AccordionSummaryProps> = ({ ...props }) => {
  return <Styled.AccordionSummary {...props} />;
};

export default React.memo(AccordionSummary);
